exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".rebookPopup {\n  position: absolute;\n  z-index: 500;\n  right: 0;\n  bottom: 15px;\n  width: 200px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js??ref--1-2!./client/assets/scripts/modules/reservations/rebook/styles.less
// module id = 302
// module chunks = 1